export default __webpack_public_path__ + "static/media/warning--tractors--g6.80093d62.png";